<template>
    <div class="app-bar-wrap">
        <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
            <v-btn class="mr-2" icon plain small @click="$emit('update:drawer', !drawer)" style="margin-left: -8px">
                <v-icon v-if="!drawer"> mdi-menu </v-icon>
                <v-icon v-else> mdi-menu-open </v-icon>
            </v-btn>
            <v-toolbar-title class="hidden-sm-and-down font-weight-light" v-text="$route.name" />
            <v-spacer />

            <v-menu offset-y v-model="showMenu" :close-on-content-click="false" v-if="user">
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-flex align-center" style="cursor: pointer">
                        <div class="mr-2 font-weight-light">
                            {{ user.email }}
                        </div>
                        <account-user-avatar class="ml-0" :user="user" :size="40"></account-user-avatar>
                    </div>
                </template>

                <v-card outlined class="my-0">
                    <v-list max-width="300">
                        <v-list-item>
                            <v-list-item-avatar>
                                <account-user-avatar class="ml-0" :user="user" :size="40"></account-user-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ user.firstName }} {{ user.lastName }}</v-list-item-title>
                                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list>
                        <v-toolbar flat height="72" class="py-4 pl-2 mt-0 transparent">
                            <v-switch v-if="settings" :input-value="$vuetify.theme.dark" @click="toggleDarkMode">
                                <template v-slot:label>
                                    <span class="pl-3 text--primary">Dark Mode</span>
                                </template>
                            </v-switch>
                        </v-toolbar>

                        <v-toolbar flat height="72" class="pb-4 pl-2 mt-1 transparent">
                            <time-zone-picker />
                        </v-toolbar>
                        <v-divider class="mt-2" />
                        <v-toolbar flat height="72" class="pb-4 mt-1 d-none"> </v-toolbar>
                    </v-list>
                    <v-btn
                        @click="showMenu = false"
                        to="/account"
                        text
                        block
                        plain
                        large
                        class="rounded-0"
                        style="padding-left: 32px !important"
                    >
                        <v-icon>mdi-account</v-icon>
                        <span class="ml-7">Account Settings</span><v-spacer />
                    </v-btn>
                    <v-btn
                        @click="logout"
                        text
                        block
                        plain
                        large
                        class="rounded-0"
                        style="padding-left: 32px !important"
                    >
                        <v-icon>mdi-logout</v-icon>
                        <span class="ml-7">Log Out</span><v-spacer />
                    </v-btn>
                    <v-divider class="mt-2" />
                    <v-btn
                        class="mt-2 rounded-0"
                        plain
                        block
                        large
                        style="padding-left: 32px !important"
                        :width="$vuetify.breakpoint.smAndUp ? '' : '100%'"
                        to="/help"
                    >
                        <v-icon>mdi-help-circle-outline</v-icon>
                        <span class="ml-7">Help</span><v-spacer />
                    </v-btn>
                </v-card>
            </v-menu>
        </v-app-bar>
    </div>
</template>

<style lang="scss">
.app-bar-wrap {
    .alert-hover:hover {
        text-decoration: underline;
        text-underline-offset: 3px;
        text-decoration-thickness: 2px;
        cursor: pointer;
    }
}
</style>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import TimeZonePicker from "@cmp/base/TimeZonePicker";
import AccountUserAvatar from "@cmp/base/AccountUserAvatar";

export default {
    name: "DashboardCoreAppBar",

    components: {
        TimeZonePicker,
        AccountUserAvatar,
    },

    computed: {
        ...mapGetters("settings", ["settings"]),
        ...mapGetters("user", ["user"]),
    },

    props: ["drawer"],

    data: () => ({
        showMenu: false,
    }),

    methods: {
        ...mapActions("user", ["logout"]),
        ...mapMutations("settings", ["toggleDarkMode"]),
    },
};
</script>
